// extracted by mini-css-extract-plugin
export var wrapper = "tab-module--wrapper--C3dQ0";
export var tabContent = "tab-module--tabContent--OP+xx";
export var nav = "tab-module--nav--aXasb";
export var navTabs = "tab-module--navTabs--0ZGsY";
export var navLink = "tab-module--navLink--ErDJ9";
export var active = "tab-module--active--AcYOA";
export var navItem = "tab-module--navItem--WOyP4";